import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关于木瓜影视在线观看的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
              style={{ animation: `fadeInUp 0.4s ease-out ${index * 0.1}s both` }}
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
              >
                <h3 className="font-medium text-foreground-950 text-sm md:text-base pr-4">{item.question}</h3>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-colors ${openId === item.id ? 'bg-primary-100 text-primary-600' : 'bg-foreground-100 text-foreground-400'}`}>
                  <i className={`${openId === item.id ? 'ri-subtract-line' : 'ri-add-line'} text-sm`}></i>
                </span>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}